import React, { useEffect, useState,useRef } from "react";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import Axios from "axios";
import {  GetCourseInfo, GetScheduledCandidatebyid_Share} from "../apiconstants/constants";
import { useLocation } from "react-router-dom";
import LoadingSpinner from "../helpers/loadingspinner";
import Modal from 'react-bootstrap/Modal';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';
import { split } from "sentence-splitter";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const HomeViewMaskInterviewCompletedCandidateDetails = () => {
    let query = useQuery();
    const GuiID = query.get("guid");
    const detailsType= query.get("detailsType");
    const selectedCountry= query.get("CountryID");
    const [candidateDetails, setCandidateDetails] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [showVideoModal, setShowVideoModal] = useState(false);
    const [currentVideoUrl, setCurrentVideoUrl] = useState('');
    const [qualifications, setQualifications] = useState([]);
    const [modalContent, setModalContent] = useState({ title: "", url: "" });
    const [jobRoles, setJobRoles] = useState([]);
    const videoRef = useRef(null); // Add ref for the video element
      const [rating, setRating] = useState([
               { ratingID: "0", ratingName: "0 - Not-Considerable", color: "red" }, // Light gray for empty
               { ratingID: "1", ratingName: "1 - Not-Considerable", color: "#dc3545" }, // Red
               { ratingID: "2", ratingName: "2 - Average Candidate", color: "#fd7e14" }, // Orange
               { ratingID: "3", ratingName: "3 - Considerable Candidate", color: "#3eed0eff" }, // Yellow
               { ratingID: "4", ratingName: "4 - Preferable Candidate", color: "#16b333ff" }, // Olive green
               { ratingID: "5", ratingName: "5 - Expert Candidate", color: "#197c19ff" }, // Dark green
             ]);
  let Guid="";
  const guid = localStorage.getItem("guid");
  const employerGuid = localStorage.getItem("employerGuid")
  const email = localStorage.getItem("email")
  const roleID = localStorage.getItem("roleID")
  
  if(roleID==3){
   Guid = employerGuid
  }
  else{
    Guid= guid
  }

  const getRatingName = (ratingID) => {
    const ratingItem = rating.find(r => r.ratingID === ratingID);
    return ratingItem ? ratingItem.ratingName : "0 - Not-Considerable";
  }
  const getRatingDetails = (ratingID) => {
  const ratingItem = rating.find(r => r.ratingID === ratingID?.toString());
  return ratingItem ? { name: ratingItem.ratingName, color: ratingItem.color } : { name: "0 - Not-Considerable", color: "#ed0b38ff" };
};

    const GetCandidateDetails = () => {
        const params = { guid: GuiID,type:detailsType };

        Axios.post(GetScheduledCandidatebyid_Share.APIURL,params)
            .then((result) => {
                setCandidateDetails(result.data);
                setIsLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching candidate details:", error);
                setIsLoading(false);
            });
    };
    const fetchQualifications = async () => {
        const getApiUrl = GetCourseInfo.APIURL;
        try {
            const response = await Axios.get(getApiUrl);
            setQualifications(response.data);
        } catch (error) {
            console.error("Error fetching qualifications", error);
        }
    };
 
    const getQualificationName = (id) => {
        const qualification = qualifications.find(q => q.qualificationID == id);
        return qualification ? qualification.courseName : "";
    };
  
    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleVideoClick = (videoURL) => {
        setCurrentVideoUrl(videoURL);
        setShowVideoModal(true);
    };
    const handleShowModal = (title, url) => {
        setModalContent({ title, url });
        setShowModal(true);
    };

    const handleClose = () => {
        setShowVideoModal(false);
        setCurrentVideoUrl('');
    };
    const getExperienceText = (experience) => {
        if (!experience) return '';
        const lowerCaseExperience = experience.toLowerCase();
        return lowerCaseExperience.includes('years') ? experience : `${experience} years`;
      };
     const formatComments = (comments) => { 
       try {
           // Try parsing only if comments is a valid JSON string
           if (typeof comments === "string" && comments.startsWith("[")) {
               const parsedComments = JSON.parse(comments);
     
               // If it's an array, format properly
               if (Array.isArray(parsedComments)) {
                   return parsedComments?.map((item, index) => (
                       <div key={index} style={{ marginBottom: 10 }}>
                           <p><strong>Question:</strong> {item.question}</p>
                           <p><strong>Answer:</strong> {item.CandidateResponse|| "No response provided"}</p>
                           <p><strong>Feedback :</strong> {item.AIEvaluationResponse || "No response provided"}</p>
                           <p><strong>Score:</strong> {item.Score}/5</p>
                           <hr />
                       </div>
                   ));
               }
           }
     
           // If it's not JSON (plain text), just display it inside <p>
           return <p>{comments}</p>;
     
       } catch (error) {
           console.error("Error parsing comments:", error);
           return <p>Error displaying comments.</p>;
       }
     };
      
      
    const renderAttachment = (fileUrl) => {
        if (fileUrl) {
            const fileExtension = fileUrl.split('.').pop().toLowerCase();
            if (fileExtension === 'pdf') {
                return (
                    <iframe src={fileUrl} title="Attachment" style={{ width: '100%', height: '500px' }} />
                );
            } else if (['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) {
                return (
                    <img src={fileUrl} alt="Attachment" style={{ width: '100%' }} />
                );
            } else if (fileExtension === 'docx') {
                return (
                    <iframe src={`https://view.officeapps.live.com/op/embed.aspx?src=${fileUrl}`} title="Attachment" style={{ width: '100%', height: '500px' }} />
                );
            } else {
                return (
                    <a href={fileUrl} target="_blank" rel="noopener noreferrer">Download Attachment</a>
                );
            }
        }
        return <p>No attachment available</p>;
    };
    const handleForward = () => {
        if (videoRef.current) {
          videoRef.current.currentTime += 10; // Forward by 10 seconds
        }
      };
    
      const handleRewind = () => {
        if (videoRef.current) {
          videoRef.current.currentTime -= 10; // Rewind by 10 seconds
        }
      };
    useEffect(() => {
        GetCandidateDetails();
        fetchQualifications();

    }, [selectedCountry]);

    return (
        <>
            {isLoading ? (
                <center><LoadingSpinner /></center>
            ) : (
                <div  class="container-fluid">
                    <h2 className="mb-3 mt-3" style={{ color: "#00a7ac" }}>Candidate Details</h2>
                    <hr/>
                    {candidateDetails && (
                         <div class="card shadow-lg mt-5 p-5" style={{border:"none"}}>
                        
                         <div class="row mt-2">
                         <div class="col-sm-12 col-lg-6 col-xl-6 col-md-6">
                            {candidateDetails.fullName!==null && candidateDetails.fullName!=='null' && 
                                                    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-name">Name</Tooltip>}>
                                                        <p className="text-para"><i className="fa fa-user icons"></i> {candidateDetails.fullName}</p>
                                                    </OverlayTrigger>
                                                }
                                                    {candidateDetails.email!==null && candidateDetails.email!=='null' && 
                                                    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-email">Email</Tooltip>}>
                                                        <p className="text-para"><i className="fa fa-envelope icons"></i> {candidateDetails.email}</p>
                                                    </OverlayTrigger>}
                        
                                                    {candidateDetails.mobileNumber!==null && candidateDetails.mobileNumber!=='null' &&    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-email">Mobile Number</Tooltip>}>
                                                        <p className="text-para"><i className="fa fa-phone icons"></i> {candidateDetails.mobileNumber}</p>
                                                    </OverlayTrigger>
                                                   }
                            {candidateDetails.address!==null && candidateDetails.address!=='null' &&  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-email">Address</Tooltip>}>
                                <p className="text-para"><i className="fa fa-map-marker icons"></i> {candidateDetails.address}</p>
                            </OverlayTrigger>}
                            {candidateDetails.experience!==null && candidateDetails.experience!=='null' &&    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-email">Experience</Tooltip>}>
                                <p className="text-para"><i className="fa fa-user-tie icons"></i> {getExperienceText(candidateDetails.experience)}</p>
                            </OverlayTrigger>
                             }
                            {candidateDetails.jobRole!==null && candidateDetails.jobRole!=='null' && candidateDetails.jobRole!==0 &&   ( 
                            <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-jobRole">Job Role</Tooltip>}>
                                <p className="text-para"><i className="fa fa-briefcase icons"></i>  {(candidateDetails.jobRoleName)}</p>
                            </OverlayTrigger>)}
                            {candidateDetails.workMode!==null && candidateDetails.workMode!=='null' && candidateDetails.workMode!==0 &&   ( 
                            <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-startDate">Work Mode </Tooltip>}>
                                <p className="text-para"><i className="fa fa-building icons"></i> {candidateDetails.workMode}</p>
                            </OverlayTrigger>)}
                      

{/* {candidateDetails.comments && candidateDetails.comments !== "null" && (
  <OverlayTrigger
    placement="bottom"
    overlay={<Tooltip id="tooltip-endDate">Comments</Tooltip>}
  >
    <div className="commenttt-wrapper">
      <i className="fa fa-comment icons mt-2 mr-2"></i>
      <ul className="text-paraaa" style={{ paddingLeft: 15, marginBottom: 0 }}>
        {split(DOMPurify.sanitize(candidateDetails.comments, { ALLOWED_TAGS: [] })
          .replace(/&nbsp;/g, " ") ) // Sanitize and split sentences
          .filter(sentence => sentence.type === "Sentence") // Only get valid sentences
          .map((sentence, index) => (
            <li key={index} style={{ marginBottom: 5 }}>{sentence.raw}</li>
          ))}
      </ul>
    </div>
  </OverlayTrigger>
)} */}
{/* {candidateDetails.comments && candidateDetails.comments !== "null" && (

 <OverlayTrigger
 placement="bottom"
 overlay={(props) => (
     <Tooltip id="tooltip" {...props}>Comments</Tooltip>
 )}
>
 <div style={{ fontSize: 14 }}>
     <i
         style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}
         className="fas fa-comment"
         aria-hidden="true"
     ></i>
     <div>{formatComments(candidateDetails.comments)}</div>
 </div>
</OverlayTrigger>
)} */}
                            {candidateDetails.rating && (
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-rating">Rating</Tooltip>}>
                                    {/* <p className="text-para"><i className="fa fa-star icons"></i> {getRatingName(candidateDetails.rating)}</p> */}
                                {(() => {
  const { name, color } = getRatingDetails(candidateDetails.rating);
  return (
    <p style={{ fontSize: 14, color }}>
      <i style={{ fontSize: 14, marginRight: 10 }} className="fas fa-star" aria-hidden="true"></i> {name}
    </p>
  );
})()}
                                </OverlayTrigger>

                            )}



                            </div>
                            <div class="col-sm-12 col-lg-6 col-xl-6 col-md-6">
                            {candidateDetails.qualificationID!==null && candidateDetails.qualificationID!=='null' && candidateDetails.qualificationID!==0 &&   ( <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-jobRole">Qualification</Tooltip>}>
                                <p className="text-para"><i className="fa fa-graduation-cap icons"></i>  {getQualificationName(candidateDetails.qualificationID)}</p>
                            </OverlayTrigger>)}
                            {candidateDetails.dob!==null && candidateDetails.dob!=='null' &&  (
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-comments">Date of Birth</Tooltip>}>
                                    <p className="text-para">
                                        <i className="fa fa-birthday-cake icons"></i> {candidateDetails.dob}</p>
                                </OverlayTrigger>
                            )}
                                {candidateDetails.gender!==null && candidateDetails.gender!=='null' && (
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-comments">Gender</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-venus-mars icons"></i> {candidateDetails.gender}</p>
                                </OverlayTrigger>
                            )}
                            {candidateDetails.workAuthorizationandValidity!==null && candidateDetails.workAuthorizationandValidity!=='null' && (
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-comments">Current Visa & First US Entry</Tooltip>}>
                                    <p className="text-para"><i className="fa fa-comment icons"></i> {candidateDetails.workAuthorizationandValidity}</p>
                                </OverlayTrigger>
                            )}
               {candidateDetails.linkedInUrl !== null && candidateDetails.linkedInUrl !== "null" && (
    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-qualification">LinkedIn Url</Tooltip>}>
        <a 
            href={candidateDetails.linkedInUrl?.startsWith('http') ? candidateDetails.linkedInUrl : `https://${candidateDetails.linkedInUrl}`} 
            target="_blank" 
            rel="noopener noreferrer"
        >
            <p className="text-para">
                <i className="fa fa-graduation-cap icons mr-1"></i>
                {candidateDetails.linkedInUrl}
            </p>
        </a>
    </OverlayTrigger>
)}
                            {candidateDetails.videoURL!==null && (
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-comments">Video URL</Tooltip>}>
                              <p className="text-para"><i className="fa fa-video icons"></i> <a href="#!" style={{fontSize:18}} onClick={() => handleVideoClick(candidateDetails.videoURL)}>View Video</a></p>
                                </OverlayTrigger>
                            )}
                                              {candidateDetails.maskedResume!==null && candidateDetails.maskedResume!=='null' &&
                             <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-resume">Resume</Tooltip>}>
                                    <p className="text-para">
                                    <a 
            href="#" 
            style={{ fontSize: 18 }} 
            onClick={() => handleShowModal('Resume', candidateDetails.maskedFileUrl)}
          >
            <i className="fa fa-file-alt icons"></i> View Resume
          </a>
          &nbsp;|&nbsp;
          <a 
            href={candidateDetails.maskedFileUrl} 
            style={{ fontSize: 18 }} 
            download
            target="_blank"
          >
            <i className="fa fa-download icons"></i> Download Resume
          </a>                                        </p>
                                </OverlayTrigger>}
                           
          
                                </div>
                                <hr/>
                                {showVideoModal && (
  <div style={{height:'auto'}}>
    {/* <video autoplay loop muted playsinline ref={videoRef} width="100%" height="90%" controls>
    <source src={candidateDetails.videoURL} type="video/webm" />
      Your browser does not support the video tag.
    </video> */}
     <div className="iframe-container">
        <iframe 
          src={candidateDetails.videoURL} 
          sandbox="allow-scripts allow-same-origin" 
          className="responsive-iframe" 
          allow="autoplay"
        ></iframe>
      </div>
    {/* <div class="text-center" style={{textAlign:"center"}}>
    <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center',marginTop:12 }}>
     
      <OverlayTrigger placement="top" overlay={<Tooltip>Rewind 10sec</Tooltip>}>
        <button onClick={handleRewind} style={{ background: "none", border: "none", marginRight: 10 }}>
          <i className="fas fa-undo" style={{ fontSize: 20, color: "#00a7ac" }}></i>
        </button>
      </OverlayTrigger>
      <OverlayTrigger placement="top" overlay={<Tooltip>Forward 10sec</Tooltip>}>
        <button onClick={handleForward} style={{ background: "none", border: "none", marginRight: 10 }}>
          <i className="fas fa-redo" style={{ fontSize: 20, color: "#00a7ac" }}></i>
        </button>
      </OverlayTrigger>
      <OverlayTrigger placement="top" overlay={<Tooltip>Download Video</Tooltip>}>
        <a href={candidateDetails.videoURL} download>
          <i className="fas fa-download" style={{ fontSize: 20, color: "#00a7ac" }}></i>
        </a>
      </OverlayTrigger>
    </div>
    </div> */}
  </div>
)}
{candidateDetails.isCustomQuestionsRequired === 0
? JSON.parse(candidateDetails?.codingIntQuns || '[]')?.length !== 0 && (
    <>
      <h2 className="mb-3 mt-3" style={{ color: "#00a7ac" }}>
        Questions
      </h2>
      {JSON.parse(candidateDetails.codingIntQuns || '[]')?.map((question, index) => (
        <div key={index}>
          <ul style={{ listStyle: "none" }}>
            <li>
              <div className="commenttt-wrapper">
                <i className="fa fa-question icons mt-2 mr-2"></i>
                <p className="text-paraaa">
                  {parse(DOMPurify.sanitize(question.question))}
                </p>
              </div>
              <div className="commenttt-wrapper">
                {question.answer !== null && (
                  <>
                    <i className="fa fa-check-square icons mt-2 mr-2"></i>
                    <p className="text-paraaa">
                      {parse(DOMPurify.sanitize(question.answer))}
                    </p>
                  </>
                )}
              </div>
            </li>
          </ul>
        </div>
      ))}
    </>
  )
: candidateDetails.questions?.length !== 0 && (
    <>
      <h2 className="mb-3 mt-5" style={{ color: "#00a7ac" }}>
        Questions
      </h2>
      {candidateDetails.questions.map((question, index) => (
        <div key={index}>
          <ul style={{ listStyle: "none" }}>
            <li>
              <div className="commenttt-wrapper">
                <i className="fa fa-question icons mt-2 mr-2"></i>
                <p className="text-paraaa">
                  {parse(DOMPurify.sanitize(question.questionName))}
                </p>
              </div>
              <div className="commenttt-wrapper">
                {question.answer !== null && (
                  <>
                    <i className="fa fa-check-square icons mt-2 mr-2"></i>
                    <p className="text-paraaa">
                      {parse(DOMPurify.sanitize(question.answer))}
                    </p>
                  </>
                )}
              </div>
            </li>
          </ul>
        </div>
      ))}
    </>
  )}

                                                         
                        </div>
                        </div>
                    )}
                </div> 
            )}
            
          
            <Modal show={showModal} onHide={handleCloseModal} size="lg">
                                    <Modal.Header closeButton>
                                        <Modal.Title>{modalContent.title}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        {renderAttachment(modalContent.url)}
                                    </Modal.Body>
                                </Modal>
        </>
    );
};

export default HomeViewMaskInterviewCompletedCandidateDetails;
